import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private http: HttpClient) { }

  saveInventory(data) {
    return this.http.put(
      `${environment.apiHost}/v1/inventory`,
      data
    );
  }

  get(data) {
    return this.http.post(
      `${environment.apiHost}/v1/inventory`,
      data
    );
  }
}
